// eslint-disable-next-line import/no-cycle
import { logException } from '../common/wscjs/analytics'
// eslint-disable-next-line import/no-cycle
import { removeUserInfo } from '../common/wscjs/user-info'
// eslint-disable-next-line import/no-cycle
import config from '../config'
import { COOKIE_AUTH_SITES } from '../constants'
// eslint-disable-next-line import/no-cycle
import { fetchLogin } from '../network'
import {
  DAZN_DOMAIN_KEY,
  LOGIN_SECONDARY_TEXT,
  OLYMPIC_DOMAIN_KEY,
  OLYMPIC_SUPPORT_EMAIL,
  SUPPORT_EMAIL,
} from './components/constants'
import { getDAZNIcon, getIcon, getOlympicIcon } from './components/mobile/utils'
import { PARTNERS_LOGIN_API_PATH } from './constants'

// Very ugly code to check if inputs were auto-refilled in Chrome
// (Chrome never dispatch a change event after auto-refilling inputs)
export function isFormAutoRefilled() {
  const inputUsername = document.querySelector('.form-group.user .input-text')
  const inputPassword = document.querySelector('.form-group.password .input-text')
  let autoRefilled = false

  if (inputUsername && inputPassword) {
    const usernameComputedStyle = window.getComputedStyle(inputUsername)
    const passwordComputedStyle = window.getComputedStyle(inputPassword)

    if (
      usernameComputedStyle &&
      passwordComputedStyle &&
      usernameComputedStyle.backgroundColor &&
      passwordComputedStyle.backgroundColor &&
      usernameComputedStyle.backgroundColor.toString() === 'rgb(250, 255, 189)' &&
      passwordComputedStyle.backgroundColor.toString() === 'rgb(250, 255, 189)'
    ) {
      autoRefilled = true
    }
  }

  return autoRefilled
}

export function getRedirectPath(endPath = '/clipro', queryParams = null) {
  const { searchParams } = new URL(window.location.href)
  const redirectPath = searchParams.get('redirect')

  if (redirectPath?.includes('localhost')) {
    return redirectPath
  }

  if (redirectPath?.includes(window.location.hostname)) {
    if (isAnySiteIncludesInRedirectUrl(redirectPath, COOKIE_AUTH_SITES)) {
      return redirectPath
    }
  }

  const url = new URL(window.location.origin + endPath)

  if (queryParams) {
    for (const [key, value] of Object.entries(queryParams)) {
      url.searchParams.set(key, value)
    }
  }

  return url.toString()
}

export function getIsAuthenticated() {
  const { searchParams } = new URL(window.location.href)

  const authenticatedParam = searchParams.get('authenticated')

  return authenticatedParam?.toLowerCase() === 'true'
}

export function isAnySiteIncludesInRedirectUrl(redirectPath, sites) {
  let result = false

  try {
    const redirectUrl = new URL(redirectPath)

    result = sites.some((site) => redirectUrl.pathname.startsWith('/' + site))
  } catch (e) {
    logException(e)
  }

  return result
}

export async function fullLogout() {
  if (config.IS_COOKIE_AUTH) {
    try {
      await fetchLogin('/', { method: 'DELETE' })
    } catch (e) {
      // DEV-87309
      // These 404 errors happens a lot, so until we will improve the flow and prevent sending of
      // these problematic requests, we don't want to log them to Sentry
      if (e.status !== 404) {
        logException(e)
      }
    }
  }

  removeUserInfo()

  // If app runs on localhost we should avoid redirection and just reload page
  // TODO: try using an environment variable (e.g. NODE_ENV) to prune this block in production
  if (config.RELEASE === 'localhost') {
    handleLocalDebugFlow()
  } else if (config.WEBSITE === 'bqpanel') {
    window.location.replace('/bqpanel')
  } else {
    const searchParams = getSearchParams()

    window.location.replace(`/login?${searchParams}`)
  }
}

export async function requestPasswordReset(userEmail, linkId, isPartnerApp) {
  try {
    if (isPartnerApp) {
      return await fetchLogin(
        `${PARTNERS_LOGIN_API_PATH}/request-password-reset?userName=${encodeURIComponent(
          userEmail,
        )}&shareableLinkId=${linkId}`,
        {
          method: 'POST',
        },
      )
    } else {
      return await fetchLogin(`/request-password-reset/${encodeURIComponent(userEmail)}`, {
        method: 'POST',
      })
    }
  } catch (ex) {
    // No matter what, moving the user to the next page as if the request succeeded.
  }
}

function getSearchParams() {
  return new URLSearchParams({
    redirect: window.location.href,
    time: Date.now(),
  }).toString()
}

function handleLocalDebugFlow() {
  if (config.WEBSITE === 'bqpanel') {
    window.location.reload()
  } else {
    const searchParams = getSearchParams()
    const servicePrefix = config.YOUTUBE_ENV
      ? `youtube${config.ENV === 'prod' ? '' : `-${config.ENV}`}`
      : `${
          config.ENV === 'prod'
            ? config.IS_EUS_ENV
              ? 'prod-eus'
              : config.IS_NORTH_EUROPE_ENV
              ? 'eu'
              : 'www'
            : config.ENV
        }`
    window.location.replace(
      `https://${servicePrefix}.${
        config.ENV === 'pr' ? 'wscsports.dev' : 'clipro.tv'
      }/login?${searchParams}`,
    )
  }
}

/**
 * Returns the appropriate API endpoint prefix based on application type and configuration.
 * @param {boolean} isPartnerApp - Indicates if the current application context is for partners.
 * @param {string} apiPath - The specific path or label to be used as the endpoint prefix.
 * @param {boolean} [prependSlash=true] - Whether to include a leading slash in the prefix.
 * @return {string} The correctly formatted endpoint prefix.
 */
export function getEndpointPrefix(isPartnerApp, apiPath, prependSlash = true) {
  if (!isPartnerApp) {
    return ''
  }

  return `${prependSlash ? '/' : ''}${apiPath}`
}

const isMatchingDomain = (domainKey) => {
  const currentDomain = window.location.hostname
  const domainPattern = new RegExp(`(?:${domainKey}|${domainKey}-uat)\\.clipro`)

  return domainPattern.test(currentDomain)
}
export function isObsDomain() {
  return isMatchingDomain(OLYMPIC_DOMAIN_KEY)
}

export function isDAZNDomain() {
  return isMatchingDomain(DAZN_DOMAIN_KEY)
}

export function clearSessionStorage(itemsToClear) {
  itemsToClear.forEach((item) => {
    sessionStorage.removeItem(item)
  })
}

export function getIsPartnerApp() {
  return Boolean(config.IS_PARTNER_APP)
}

export const getSupportEmailAddress = ({ isOlympicEnv }) => {
  return isOlympicEnv ? OLYMPIC_SUPPORT_EMAIL : SUPPORT_EMAIL
}

export const getLoginSecondaryText = ({ isDAZNEnv }) => {
  return isDAZNEnv ? '' : LOGIN_SECONDARY_TEXT
}

export const getIconByEnv = ({ isOlympicEnv, isDAZNEnv, isMobile }) => {
  return isOlympicEnv
    ? getOlympicIcon(isMobile)
    : isDAZNEnv
    ? getDAZNIcon(isMobile)
    : getIcon(isMobile)
}
